import { Platform } from 'ionic-angular';
import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class FaqProvider {
  faqs: any = [];
  faq_category: any = [];
  constructor(public gateway: GatewayClientProvider, public platform: Platform) {
  }

  getFaqs(category_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getFaqs(category_id).then((result: any) => {
        self.faqs = result.data;
        resolve(self.faqs);
      })
        .catch((error) => { reject(error) });
    });
  }

  getFaqCategory() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getFaqCategory().then((result: any) => {
        self.faq_category = result.data.filter((x) => x.isactive == 1);
        resolve(self.faq_category);
      })
        .catch((error) => { reject(error) });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/faq/faq.ts